import "slick-carousel";

const templateHome = {
  init: function () {
    templateHome.init_slider();
    templateHome.init_categories();
    templateHome.init_partners();
    templateHome.init_testimonials();
  },

  init_slider: function () {
    $(".hero__slider").on("init", function () {
      bLazy.load($(".hero__lazy"));
      $(".slick-current .hero__item__inner")
        .children()
        .each(function () {
          $(this).addClass("fade-in");
        });
    });

    $(".hero__slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      fade: false,
      autoplay: true,
      dots: false,
      arrows: true,
      prevArrow: $(".hero .slick__prev"),
      nextArrow: $(".hero .slick__next"),
      autoplaySpeed: 3000,
      adaptiveHeight: true,
    });

    $(".hero__slider").on("afterChange", function () {
      $(".slick-current .hero__item__inner")
        .children()
        .each(function () {
          $(this).addClass("fade-in");
        });
    });

    $(".hero__slider").on(
      "beforeChange",
      function (e, slick, currentSlide, nextSlide) {
        $(".slick-current .hero__item__inner")
          .children()
          .each(function () {
            $(this).removeClass("fade-in");
          });
      }
    );
  },

  init_categories: function () {
    $(".categories__slider").on("beforeChange", function () {
      $(".categories__slider").addClass("has-changed");
    });
    $(".categories__slider").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      draggable: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            swipeToSlide: true,
            infinite: true,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },

  init_partners: function () {
    $(".partners__slider").slick({
      infinite: true,
      rows: 0,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".partners .slick__prev"),
      nextArrow: $(".partners .slick__next"),
      lazyLoad: "progressive",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },

  init_testimonials: function () {
    $(".testimonials__slider").on("init", function () {
      bLazy.load($(".testimonials__person__thumb"));
    });

    $(".testimonials__slider").slick({
      adaptiveHeight: false,
      centerMode: true,
      variableWidth: true,
      draggable: true,
      arrows: false,
      dots: true,
      focusOnSelect: true,
    });
  },
};

export default templateHome;
